<template>
  <div>
    <section>
      <div class="over-table">
        <search-bar
          class="search-user"
          @input="input => (search = input)"
        />
        <div class="add-workplace">
          <button
            class="clavo-button clavo-button-action"
            @click="showNewLocation = true"
          >
            {{ $t('addWorkplace') }}
          </button>
          <location-add-edit
            v-if="showNewLocation"
            :user-id="userId"
            :already-used-colors="locations.map(loc => loc.color)"
            :already-used-workplace-names="locations.map(loc => loc.name)"
            @close="showNewLocation = false"
            @save="load"
          />
        </div>
      </div>

      <locations
        class="fullspan"
        :searched-name="search"
        :locations="locations"
        :location-color-names="locationColorNames"
        @delete-location="removeLocationFromList"
      />
    </section>
  </div>
</template>

<script>
import SearchBar from '@/components/UI/SearchBar'
import User from '@/components/User'
import Locations from '@/components/Location/WorkplacesList'
import LocationAddEdit from '@/components/Location/AddEdit'
import Parse from 'parse'

export default {
  components: {
    Locations,
    LocationAddEdit,
    SearchBar,
  },
  mixins: [User],
  props: {},
  data() {
    return {
      newWorkplaceName: '',
      showNewLocation: false,
      search: '',
      locations: [],
      locationColorNames: {},
      placeholder: 'Search',
    }
  },
  async created() {
    this.load()
  },
  methods: {
    load() {
      const _this = this

      Parse.Cloud.run('locations', {}, {})
        .then(function(response) {
          _this.locations = response.map(parseObj => Object.assign({}, parseObj.attributes, { id: parseObj.id }))
        })
        .then(async function() {
          for (var i = 0; i < _this.locations.length; i++) {
            if (!(_this.locations[i].color in _this.locationColorNames))
              _this.$set(_this.locationColorNames, _this.locations[i].color, await _this.hex2name(_this.locations[i].color))
          }
        })
    },
    removeLocationFromList(locationId) {
      this.locations = this.locations.filter(l => l.id !== locationId)
    },
  },
}
</script>

<style lang="scss" scoped>
section {
  margin: 18px 0 19px 0;

  @include respond-above(sm) {
    .over-table {
      display: flex;
      position: relative;
      flex-direction: row;

      .search-user {
        margin: 0 18px 18px 18px;
        width: 50%;
      }

      .add-workplace {
        button {
          position: absolute;
          right: 36px;
        }
      }
    }
  }

  @include respond-below(sm) {
    .over-table {
      display: flex;
      flex-direction: column;

      .search-user {
        margin: 0 18px 9px 18px;
        width: 85%;
      }

      .add-workplace {
        button {
          margin: 9px 18px 18px 18px;
          width: 85%;
          height: 32px;
        }
      }
    }
  }
}
</style>
